// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:38
import { CTacticalSituationBase } from '../../SagaSchema/CTacticalSituationBase';
import * as SagaSchema from '../../SagaSchema';
import { Guid, GuidTools } from '@models/guid';

export abstract class CTacticalSituationTemplate_abstract extends CTacticalSituationBase {
  static $t: string = 'SagaSchema.CTacticalSituationTemplate';
  $t: string = 'SagaSchema.CTacticalSituationTemplate';

  public static GetMembers(): string[] {
    return [].concat(CTacticalSituationBase.GetMembers());
  }

  public GetMembers(): string[] {
    return CTacticalSituationTemplate_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
